import './App.css';
import DocSum2 from './Components/DocSum/DocSum2';
import RichTextEditor from './Components/DocSum/textEditor';
import PDFViewerWithDrawing from './Components/PdfPage/pdfDrawTest';
import RouterPage from './Components/RoutePage';

function App() {
  return (
    // <div className="App">
    <div className="App">
        <RouterPage />
        {/* <DocSum2 /> */}
        {/* <RichTextEditor /> */}
        {/* <PDFViewerWithDrawing /> */}
    </div>
  );
}

export default App;
